import { render, staticRenderFns } from "./MdfeDetailsForm.vue?vue&type=template&id=f1d8bb98&scoped=true&"
import script from "./MdfeDetailsForm.vue?vue&type=script&lang=js&"
export * from "./MdfeDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./MdfeDetailsForm.vue?vue&type=style&index=0&id=f1d8bb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d8bb98",
  null
  
)

export default component.exports